import { useAuth0 } from "@auth0/auth0-react";
import { useAtomValue, useSetAtom } from "jotai";
import { loadable } from "jotai/utils";

import {
	$inviteWorkspaceMembers,
	$removeWorkspaceMembers,
	$workspaceMembers,
} from "../../internal/workspaces/workspace-members.atom";
import { type Workspace } from "../../internal/workspaces/workspace.types";

export const useWorkspaceMemberships = (workspace: Workspace) => {
	const { isAuthenticated } = useAuth0();

	const membersAtom = $workspaceMembers(workspace);

	const membersLoadable = useAtomValue(loadable(membersAtom));
	const membersValue = membersLoadable.state === "hasData" ? membersLoadable.data : [];
	const removeMembers = useSetAtom($removeWorkspaceMembers);
	const inviteMembers = useSetAtom($inviteWorkspaceMembers);

	const members = isAuthenticated ? membersValue : [];

	return {
		members,
		removeMembers,
		inviteMembers,
		isLoading: membersLoadable.state === "loading",
		isError: membersLoadable.state === "hasError",
		error: membersLoadable.state === "hasError" ? membersLoadable.error : undefined,
	};
};
